import React from 'react';
import { Tag } from 'carbon-components-react';

interface Props {
  /** Geodesic area in km² or length in km, depending on the active tool. */
  liveArea: number | undefined;
  activeTool: string;
}

/**
 * Displays real-time area or length while the user is drawing.
 * Same display logic as the lodge-enquiry LiveAreaTag but receives
 * the value as a prop instead of reading from Redux, so it works
 * with the isolated member lookup map.
 */
const MemberLookupLiveAreaTag: React.FC<Props> = ({ liveArea, activeTool }) => {
  if (liveArea === undefined) return null;

  return (
    <div className="live-area-tag">
      <Tag type="high-contrast" title="Live area">
        {activeTool === 'polyline' ? (
          <>
            {'LENGTH '}
            <span className="value">
              {liveArea > 1
                ? `${liveArea.toFixed(2)} km`
                : `${Number(liveArea * 1000).toFixed(2)} m`}
            </span>
          </>
        ) : (
          <>
            {'LIVE AREA '}
            <span className="value">
              {liveArea > 0.01
                ? `${liveArea.toFixed(2)} km²`
                : `${Number(liveArea * 1e6).toFixed(2)} m²`}
            </span>
          </>
        )}
      </Tag>
    </div>
  );
};

MemberLookupLiveAreaTag.displayName = 'MemberLookupLiveAreaTag';

export default React.memo(MemberLookupLiveAreaTag);
